var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 13V11.6667C12.3333 10.9594 12.0523 10.2811 11.5522 9.78105C11.0521 9.28095 10.3739 9 9.66663 9H4.33329C3.62605 9 2.94777 9.28095 2.44767 9.78105C1.94758 10.2811 1.66663 10.9594 1.66663 11.6667V13M9.66663 3.66667C9.66663 5.13943 8.47272 6.33333 6.99996 6.33333C5.5272 6.33333 4.33329 5.13943 4.33329 3.66667C4.33329 2.19391 5.5272 1 6.99996 1C8.47272 1 9.66663 2.19391 9.66663 3.66667Z",
    stroke: "#98A2B3",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default "data:image/svg+xml,%3csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M12.3333 13V11.6667C12.3333 10.9594 12.0523 10.2811 11.5522 9.78105C11.0521 9.28095 10.3739 9 9.66663 9H4.33329C3.62605 9 2.94777 9.28095 2.44767 9.78105C1.94758 10.2811 1.66663 10.9594 1.66663 11.6667V13M9.66663 3.66667C9.66663 5.13943 8.47272 6.33333 6.99996 6.33333C5.5272 6.33333 4.33329 5.13943 4.33329 3.66667C4.33329 2.19391 5.5272 1 6.99996 1C8.47272 1 9.66663 2.19391 9.66663 3.66667Z' stroke='%2398A2B3' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };